 /*	MARK: Subscription Manage
	============================================
 */
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request, AuthRequest } from '../services/data-service';
import { Api } from '../services/api';

//const Subscriptions = { "Pro":"Pro", "Basic":"Basic", "Enterprise":"Enterprise"};

const Subscriptions = {
	"Pro": {
		type:"Pro", code:"PRO0625",
		billing_period:"Annual", ammount:355,
		cases:3, storage:1500, trainings:18, predictions:20000
	},
	"Basic": {
		type:"Basic", code:"BASIC0625",
		billing_period:"Annual", ammount:60,
		cases:1, storage:500, trainings:8, predictions:10000
	},
	"Enterprise": {
		type:"Enterprise", code:"ENTERPRISE0625",
		billing_period:"Annual", ammount:0,
		cases:"custom", storage:"custom", trainings:"custom", predictions:"custom"
	},
};

@inject(DataService, Api)
export class SettingsSubscriptionManage {
	/* MARK: Component life cycle
	   =================================
	*/
	constructor(ds, api){
		this.ds		= ds;
		this.api	= api;
		// Custom vars
		this.Subscriptions 		= Subscriptions;
		this.userSubscription 	= {};

		//this.expires;
		//this.amount;
		//this.billingFreq;
		this.isAnnual			= true;
		this.user_info			= {};

	}

	activate(params){
		// window.setTimeout( () => {}, 600);
	}

	attached(){
		window.setTimeout( () => { this.init(); }, 1000);
	}
	
	/* MARK: Custom methods
	   =================================
	*/
	init(){

		// Get user info
		if(!this.ds.user_info){
			// Get remote user info
			this.ds.getUserInfo().then(res => {
				this.user_info 			= res.data;
				this.userSubscription 	= this.user_info.subscription;
			});
		}
		else{
			// Procede
			this.user_info 			= this.ds.user_info;
			this.userSubscription 	= this.user_info.subscription;
		}
	}

	/* MARK: Remote API Calls
	   --------------------------------------------
	*/

	
	postSubscription(subs, uid){
		let authRequest 	= new AuthRequest("/api/v2/subscriptions/", "POST");

		let subscription	= { type:subs.type, billing_period:subs.billing_period, code:subs.code}
		let body 			= { subscription:subscription, uid:uid };
		authRequest.body	= JSON.stringify(body);
		//console.log("body => ", body);
		return this.api.post(authRequest);
	}

	handlePostSubscription(response){
		console.log("subs res => ", response);
	}

	/* MARK: Payment authorization process
	   --------------------------------------------
	   1 Make payment -> obtain payment auth
	   2 Gen Authorization Token at Samantia Auth
	   3 Create montly usage at Samantia App
	*/

	subscribe(subs){

		let uid 		= this.ds.user.uid;
		this.postSubscription(subs, uid)
			.then(res => { this.handlePostSubscription(res);});
	}

	
	
	backNavi(){ if(history.length != 0){history.back();}}
	displayDate(date){ let d = new Date(date);return d.toDateString();}

	billingFreq(){
		let isAnnual = this.isAnnual
		this.Subscriptions.Pro.billing_period = (isAnnual) ? "Annual" : "Monthly";
		this.Subscriptions.Basic.billing_period = (isAnnual) ? "Annual" : "Monthly"
		this.Subscriptions.Enterprise.billing_period = (isAnnual) ? "Annual" : "Monthly"
	}
}
